export const noForgetPwdInstitutes = {
  // "sriabhidakp.onesaz.com": true,
  "miity.onesaz.com": false,
};
